import Task from './Task';
import { createError } from '../error';

const opportunityInvitationResponsePath = '/staffing_user/{staffing_users_id}/opportunity_invitations/{opportunity_invitations_id}/response';

class OpportunityInvitationResponseTask extends Task {
  constructor(
    $q,
    APIService,
    LogService
  ) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.LogService = LogService;
  }

  /**
   * Public properties
   */

  get canExecute() {
    return this.APIService.isOnline;
  }

  set staffUserId(id) {
    this._staffUserId = id;
  }

  get staffUserId() {
    return this._staffUserId;
  }

  set opportunityInvitationId(id) {
    this._opportunityInvitationId = id;
  }

  get opportunityInvitationId() {
    return this._opportunityInvitationId;
  }

  set response(response) {
    this._response = response;
  }

  get response() {
    return this._response;
  }

  /**
   * Public methods
   */

  populate(data) {
    this.staffUserId = data.staffUserId;
    this.opportunityInvitationId = data.opportunityInvitationId;
    this.response = data.response;
  }

  serialize() {
    return {
      staffUserId: this.staffUserId,
      opportunityInvitationId: this.opportunityInvitationId,
      response: this.response,
    };
  }

  execute() {
    const path = opportunityInvitationResponsePath
      .replace('{staffing_users_id}', this.staffUserId)
      .replace('{opportunity_invitations_id}', this.opportunityInvitationId);
    const postData = {
      response: this.response,
    };

    return this.APIService.post(path, postData)
      .then(response => {
        return response;
      })
      .catch(response => {
        this.LogService.error(`OpportunityInvitationSaveTask.execute() got error response:`, response);
        return this.$q.reject(createError({
          error: 'ErrorUpdatingOpportunityInvitationResponse',
          description: 'Error updating opportunity invitation response',
          response,
        }));
      })
  }
}

export default OpportunityInvitationResponseTask;
